import routes from '@routes';
import { CacheProps, fetchApi } from '../../fetch';

interface userItemApiProps extends CacheProps {
  slug: string
}

const getUserItemApi = async ({ slug, ...rest }: userItemApiProps) => {
  const res = await fetchApi({
    method: 'GET',
    URL: {
      pathname: routes['api.users.show'],
      query: {
        slug: slug,
      },
    },
    ...rest,
  });

  return {
    userItem: res?.data || [],
    notFound: !res?.ok || null,
    userContacts: res?.data?.contacts?.data || null,
    userEducations: res?.data?.educations?.data || null,
    userInsurances: res?.data?.insurances?.data || null,
    userExperiences: res?.data?.experiences?.data || null,
    userServices: res?.data?.services?.data || null,
    userServiceFee: res?.data?.serviceFee?.data || null,
  };
};

export default getUserItemApi;
